// Extracted from UserInformation: importing it there would create a cycle, since
// UserInformation renders ConnectButton.
export const makeWeTokenCalls = (wrapper: { address?: string } | undefined, userAddress: string | undefined) =>
  wrapper?.address
    ? [
        { address: wrapper.address, abi: "WEToken", method: "balanceOf", args: [userAddress] },
        { address: wrapper.address, abi: "WEToken", method: "convertToAssets", args: [10n ** 18n] },
      ]
    : [];
